import { useEffect, useState } from 'react';

import { loadTemplateSession } from './planTemplateSource';
import { useLocale } from '../primitives/useLocale';
import type { ProgramApiFetch } from '../ProgramEditor/types';

// The name of the plan or program behind a session (#318), resolved at render.
// Undefined for an ad-hoc log or an unresolved template.
export function useTemplateName(
  planRef: string | undefined,
  apiFetch: ProgramApiFetch,
): string | undefined {
  const lang = useLocale();
  const [name, setName] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!planRef) {
      setName(undefined);
      return;
    }
    let alive = true;
    void (async () => {
      const session = await loadTemplateSession(planRef, apiFetch, lang);
      if (alive) setName(session?.name);
    })();
    return () => {
      alive = false;
    };
  }, [planRef, apiFetch, lang]);

  return name;
}
